export const dummyChats = [
  {
    uid: 'dummy',
    displayName: '오감자핫칠리소스조강현',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '악질인사람',
    photoURL: 'dummy',
    msg: '??',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '포칸',
    photoURL: 'dummy',
    msg: '제발',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'gotop456',
    photoURL: 'dummy',
    msg: '다들 잘가',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'insengmangham',
    photoURL: 'dummy',
    msg: 'ㅅㄱ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '조국추미애박원순오거돈',
    photoURL: 'dummy',
    msg: '밴 ㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '슈루루룩',
    photoURL: 'dummy',
    msg: '죽는다',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '파카를입은손인욱',
    photoURL: 'dummy',
    msg: '컽',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '바다노래',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'greendaylovercoin',
    photoURL: 'dummy',
    msg: '머함',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'tangru99',
    photoURL: 'dummy',
    msg: '움직임을 멈추셨네',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'offline0000',
    photoURL: 'dummy',
    msg: '밴하느라 ㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'yyyyuyy',
    photoURL: 'dummy',
    msg: '??',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '병렬이',
    photoURL: 'dummy',
    msg: '히이익',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '개재석99',
    photoURL: 'dummy',
    msg: '다죽네',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '양념게장콤보',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'vkfksahwk22',
    photoURL: 'dummy',
    msg: '아 세로로 엄준식을~',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '인천머장박용성',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김해미드폭격기김찬호',
    photoURL: 'dummy',
    msg: '처형?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'GHeeH',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '악질인사람',
    photoURL: 'dummy',
    msg: '뭐야',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'sazaso2',
    photoURL: 'dummy',
    msg: '힘내 돌거북',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '민간인중',
    photoURL: 'dummy',
    msg: '어그로 끌린놈들이 넘많아',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '이게바로나박종혁이다',
    photoURL: 'dummy',
    msg: '딸깍딸깍',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '대박나이스빠셍',
    photoURL: 'dummy',
    msg: '악질 놈들 다 검거 완료 다 나가',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '모하냐고',
    photoURL: 'dummy',
    msg: '이렐죽는다',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'againrock00',
    photoURL: 'dummy',
    msg: '딸깍',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '은빈타자기',
    photoURL: 'dummy',
    msg: '헐',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'booribori',
    photoURL: 'dummy',
    msg: 'ㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'Direct Relief - Charity 2018치과',
    photoURL: 'dummy',
    msg: '졸업 ㅊㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '아캅스',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '칼리버66',
    photoURL: 'dummy',
    msg: '??',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '중국어하는백수',
    photoURL: 'dummy',
    msg: '선생님',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '리버스',
    photoURL: 'dummy',
    msg: '언년이야!!!',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'Prime Gaming아약스암스테르담',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '이천사백꿈나무',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김해오마카세매니아김찬호',
    photoURL: 'dummy',
    msg: '파카님 주거요~',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'neo0231',
    photoURL: 'dummy',
    msg: '딸깍',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '랄로동생파카',
    photoURL: 'dummy',
    msg: '죽으면 레전드 ㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '중국어하는백수',
    photoURL: 'dummy',
    msg: '돌거북',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'againrock00',
    photoURL: 'dummy',
    msg: '"딸깍"',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '눈꽃다람쥐',
    photoURL: 'dummy',
    msg: '선생님 죽어요',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'showme1111',
    photoURL: 'dummy',
    msg: '죽어라죽어라',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '귤선장님',
    photoURL: 'dummy',
    msg: '선생님 죽어요',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '작은매화나무',
    photoURL: 'dummy',
    msg: '설마 다죽임?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '일산황제원유상',
    photoURL: 'dummy',
    msg: '어어',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '최강무적어썸동현',
    photoURL: 'dummy',
    msg: '돌거북 화이팅',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '버터마가린',
    photoURL: 'dummy',
    msg: 'ㄴㄴㄱ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '싹둑',
    photoURL: 'dummy',
    msg: '콩쥐팥쥐괴물쥐 -> 특수문자 도배에 주의해주세요. [경고]',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '구본승',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '세로엄준식을완성한조강현',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김찬호세상을놀라게하다',
    photoURL: 'dummy',
    msg: '무차별폭격',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '히히오스',
    photoURL: 'dummy',
    msg: '주거요!!',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '도랄팍저장소',
    photoURL: 'dummy',
    msg: '뭐하긴 니네 다 쳐내는중이지 ㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'offline0000',
    photoURL: 'dummy',
    msg: '죽어요~~',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '너무훌륭하고',
    photoURL: 'dummy',
    msg: '죽어요 선생님',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '지수짱짱맨',
    photoURL: 'dummy',
    msg: '졸업 ㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '중국어하는백수',
    photoURL: 'dummy',
    msg: '선생님죿어요',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'zfxgch1029',
    photoURL: 'dummy',
    msg: '어어',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'silkcocoon',
    photoURL: 'dummy',
    msg: '칼춤ON',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '슈루루룩',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '남양주제갈공명',
    photoURL: 'dummy',
    msg: '응애',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '일산황제원유상',
    photoURL: 'dummy',
    msg: '죽는다 ㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '지중해_백상어',
    photoURL: 'dummy',
    msg: '죽겠는데?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김치만두좋아요',
    photoURL: 'dummy',
    msg: '?????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'chrcod99',
    photoURL: 'dummy',
    msg: '죽어',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'pizzaberry9',
    photoURL: 'dummy',
    msg: '처형당하겟다',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '최강무적어썸동현',
    photoURL: 'dummy',
    msg: '어?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'Prime Gaming넘버나인',
    photoURL: 'dummy',
    msg: '골렘에게 죽을사람',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '경비병두목',
    photoURL: 'dummy',
    msg: '떨마',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '버닝워닝',
    photoURL: 'dummy',
    msg: '댕겅댕겅',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '유우키',
    photoURL: 'dummy',
    msg: '나죽어',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '중국어하는백수',
    photoURL: 'dummy',
    msg: '죽어요',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'sexkingralo2',
    photoURL: 'dummy',
    msg: '????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '리시94',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '병렬이',
    photoURL: 'dummy',
    msg: '오잉?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '수아오오오',
    photoURL: 'dummy',
    msg: '죽어요',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'GLHF Pledge레이메이',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '댁스',
    photoURL: 'dummy',
    msg: '이걸?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'al1ice',
    photoURL: 'dummy',
    msg: '거북이 개빡딜',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '육식동물',
    photoURL: 'dummy',
    msg: '어?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'Direct Relief - Charity 2018치과',
    photoURL: 'dummy',
    msg: '돌커북 1/0/0',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '천연물',
    photoURL: 'dummy',
    msg: '컽컽컽',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '사이버미아',
    photoURL: 'dummy',
    msg: '죽겠다',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '99도의물',
    photoURL: 'dummy',
    msg: 'wnrdjt',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '청갭구리',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '칼리버66',
    photoURL: 'dummy',
    msg: '어뷰임?? ?????????????????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '일산황제원유상',
    photoURL: 'dummy',
    msg: '컽',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김치만두좋아요',
    photoURL: 'dummy',
    msg: 'ㅂㅂ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '임쟌님',
    photoURL: 'dummy',
    msg: '선생님',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '장만월이지안신디이지금',
    photoURL: 'dummy',
    msg: '안대',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '팤랄굽슥',
    photoURL: 'dummy',
    msg: '죽는다',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '리시94',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'silkcocoon',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'toge_chu',
    photoURL: 'dummy',
    msg: '캬',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '99도의물',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '벡터맨01',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'fancyart47',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '박조롱',
    photoURL: 'dummy',
    msg: '자~ 드가자~',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '고래이야기',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '이게맞는건가',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '란팡',
    photoURL: 'dummy',
    msg: '팍넛ㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'dopaminc',
    photoURL: 'dummy',
    msg: '다죽네',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '바다노래',
    photoURL: 'dummy',
    msg: '처형',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '꿍깡끽',
    photoURL: 'dummy',
    msg: '간다!',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'redheal13',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'goodfireman',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '중국어하는백수',
    photoURL: 'dummy',
    msg: '형..',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '노랑색플랫폼',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '최강무적어썸동현',
    photoURL: 'dummy',
    msg: '????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'kjsklh123',
    photoURL: 'dummy',
    msg: '죽어요',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '에쎄체인지프로즌',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '기포27',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김해미드폭격기김찬호',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '호오오우',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '남양주제갈공명',
    photoURL: 'dummy',
    msg: '어',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '뇨뇽뇨뇽',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '싹둑',
    photoURL: 'dummy',
    msg: '재규어는빠르다 -> 특수문자 도배에 주의해주세요. [경고]',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'wkdrns276',
    photoURL: 'dummy',
    msg: '??',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'gdh1285',
    photoURL: 'dummy',
    msg: '>',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'junsick_god',
    photoURL: 'dummy',
    msg: 'zzzzzzzzzzzzzzzzzzzzzzz',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '구본승',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '벼랑위의표노',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '청갭구리',
    photoURL: 'dummy',
    msg: 'zjt',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '착하디착한말만하는사람',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '유우키',
    photoURL: 'dummy',
    msg: '????????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '문슁스',
    photoURL: 'dummy',
    msg: '안돼!!!!!!!!!!!!!!!!!',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'vkfksahwk22',
    photoURL: 'dummy',
    msg: '선생님?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '히히오스',
    photoURL: 'dummy',
    msg: '앗...',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'spikeice0',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'greendaylovercoin',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'sky20202',
    photoURL: 'dummy',
    msg: '??',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '하모닉하',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김망그',
    photoURL: 'dummy',
    msg: '컽',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '포칸',
    photoURL: 'dummy',
    msg: '이사람 트롤인가요?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'lhjlhj2005',
    photoURL: 'dummy',
    msg: '??????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'neal1212kdk2345',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'akamoon385',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '양념게장콤보',
    photoURL: 'dummy',
    msg: '휠체어 넘어졌네',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '송머환',
    photoURL: 'dummy',
    msg: 'ㄷㄷ?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '트룰라삠빰',
    photoURL: 'dummy',
    msg: '으악',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'GLHF Pledge레이메이',
    photoURL: 'dummy',
    msg: '????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '비디어',
    photoURL: 'dummy',
    msg: '황거북 ㄷㄷ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김해오마카세매니아김찬호',
    photoURL: 'dummy',
    msg: '억..',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '사이버미아',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '낙지장사',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'junsick_god',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'niceman272',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'dandaeng',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '박조롱',
    photoURL: 'dummy',
    msg: '이거지',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '랄로동생파카',
    photoURL: 'dummy',
    msg: '응애!',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'dopaminc',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '파카를입은손인욱',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '오즈의모코코',
    photoURL: 'dummy',
    msg: '??? 머함',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '이게맞는건가',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㄴ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김찬호세상을놀라게하다',
    photoURL: 'dummy',
    msg: '?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '개재석99',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '조국추미애박원순오거돈',
    photoURL: 'dummy',
    msg: '밴하느라 처형 ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '중이니',
    photoURL: 'dummy',
    msg: '휠체어 넘어짐??',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김경민김기현김남제김혜성',
    photoURL: 'dummy',
    msg: '와 ㄷㄷ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'WhyJei',
    photoURL: 'dummy',
    msg: '????????????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '로무띠',
    photoURL: 'dummy',
    msg: '어디감',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '기포27',
    photoURL: 'dummy',
    msg: '???????????????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '최강무적어썸동현',
    photoURL: 'dummy',
    msg: '팅이다',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '김치만두좋아요',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'tangru99',
    photoURL: 'dummy',
    msg: '팀원이 핑을 찍어버렸네요',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '강한육군굳건이',
    photoURL: 'dummy',
    msg: '딸각딸각',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'Heatscan_',
    photoURL: 'dummy',
    msg: '???',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'toge_chu',
    photoURL: 'dummy',
    msg: '컽',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'Direct Relief - Charity 2018치과',
    photoURL: 'dummy',
    msg: '킹거북',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'silkcocoon',
    photoURL: 'dummy',
    msg: '"물음표핑"',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '은빈타자기',
    photoURL: 'dummy',
    msg: '??',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '벡터맨01',
    photoURL: 'dummy',
    msg: '?????????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '시사밈',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '수아오오오',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋ선생님 머하세여 ㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'dandaeng',
    photoURL: 'dummy',
    msg: '선생님 죽어요',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '일산황제원유상',
    photoURL: 'dummy',
    msg: '???',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '엄카털린엄준식',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '2ephus',
    photoURL: 'dummy',
    msg: '와난',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '호날두와일본여행간김찬호',
    photoURL: 'dummy',
    msg: '응애',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'todwlsve',
    photoURL: 'dummy',
    msg: '??????????',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'GHeeH',
    photoURL: 'dummy',
    msg: 'ㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋㅋ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: 'showme1111',
    photoURL: 'dummy',
    msg: 'ㅈㄷㄹㅇ',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '코그댕',
    photoURL: 'dummy',
    msg: '어...뷰,...',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  },
  {
    uid: 'dummy',
    displayName: '오히려이득이야',
    photoURL: 'dummy',
    msg: '무슨일인데 그럼?',
    likes: 0,
    fans: [],
    pinned: false,
    delete: false
  }
]
